import { styled } from 'styled-components';

export const Wrapper = styled.div`
    & > div {
        display: flex;
        justify-content: space-between;
    }

    .price {
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 130%;
        color: #1f2547;
        margin-bottom: 8px;
    }

    .price_info {
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 120%;
        color: #1f2547;
    }
`;

export const PriceBlock = styled.div`
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 120%;
    color: #1f2547;
    margin-bottom: 16px;
`;
